import map from "lodash/map";
import mapKeys from "lodash/mapKeys";
import mapValues from "lodash/mapValues";
import moment from "moment";
import crossfilter from "crossfilter";
export const formatTrafficData = (traffic) => {
  const ndx = crossfilter(map(traffic, (value, key) => ({ ts: key, bytes: value })));
  const dailyTraffic = ndx.dimension((d) => moment.utc(d.ts).format("YYYY-MM-DD"));
  const dailySums = dailyTraffic.group().reduceSum((d) => d.bytes);
  const t = mapKeys(dailySums.all(), (entry) => moment.utc(entry.key, "YYYY-MM-DD").toISOString());
  return mapValues(t, (val) => val.value);
};
export default {
  formatTrafficData
};
